import Attribute from "./Attribute";
import EntityType from "./EntityType";
import EntityDefinitions from "../App/EntityDefinitions";

class RemoteRefAttribute extends Attribute {
    constructor(name, def) {
        super(name, def);
        this.type = 'remoteref';
        this.subtype = def.type.refType;
        this.refAttribute = def.type.refAttribute;
        this.definition = def.type.definition;
    }

    fromJson(data) {
        if (data === null || typeof data !== 'object') {
            return data;
        }

        if (!Array.isArray(data)) {
            data = [data];
        }

        for (let i=0; i<data.length; i++) {
            if (typeof data[i] !== 'object') {
                return data;
            }
        }

        const et = new EntityType(this.definition || EntityDefinitions.getDefinition(this.subtype));
        return data.map(e => et.createEntity(e));
    }
}

export default RemoteRefAttribute;